var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('alert-modal',{attrs:{"name":"critical-error","alert":_vm.$t('SERVER_ERROR_RELOAD_CTA'),"title":_vm.$t('SERVER_ERROR_HEADER')},on:{"dismiss":_vm.onDismiss}},[_vm._v("\n  "+_vm._s(_vm.$t('SERVER_ERROR_SUPPORTING'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }